import { render } from "./CustomerOffcanvas.vue?vue&type=template&id=a95c9fa6"
import script from "./CustomerOffcanvas.vue?vue&type=script&lang=js"
export * from "./CustomerOffcanvas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__